<script lang="ts">
    import { active_page, page_size } from "$components/episodes/gallery_store";
    export let length: number = 0;
    $: number_of_pages = Math.ceil(length / $page_size);
</script>

<div class="buttons">
    <button
        on:click={() => {
            if ($active_page >= 2) $active_page -= 1;
        }}
        disabled={$active_page === 1}
    >
        <svg
            style:transform="rotate(180deg)"
            fill="none"
            viewBox="0 0 24 24"
            height="24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071Z"
                fill="currentColor"
            />
        </svg>
        Prev Gallery Page
    </button>
    <button
        on:click={() => {
            if ($active_page !== number_of_pages) $active_page += 1;
        }}
        disabled={$active_page === number_of_pages}
    >
        Next Gallery Page
        <svg
            fill="none"
            viewBox="0 0 24 24"
            height="24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071Z"
                fill="currentColor"
            />
        </svg>
    </button>
</div>

<style>
.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
@media (max-width: 450px) {
  .buttons {
    flex-flow: column;
    gap: 1rem;
    margin-bottom: 2rem;
  }
  .buttons button {
    margin: 0 !important;
  }
}
.buttons button {
  border: 1px solid var(--dots);
  border-radius: 1rem;
  background: white;
  padding: 1rem 1.2rem;
  display: flex;
  gap: 1rem;
  background: var(--secondary);
  color: white;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  align-items: center;
  justify-content: center;
}
.buttons button:hover {
  background: var(--primary);
}
.buttons button:disabled {
  background: var(--dots);
  color: var(--offDark);
  cursor: default;
}
.buttons button:disabled svg {
  opacity: 0.2;
}
</style>
